module.exports = __webpack_public_path__ + "img/logoS6.ca13cbc9.png";